import { Injectable } from '@jkhy/frontend-utils/di';
import { ArpClient } from '@treasury/api/channel';

@Injectable()
export class CentrixSsoService {
    constructor(private readonly arpClient: ArpClient) {}

    /**
     * Fetches the Centrix SSO login URL from the ARP API.
     * @returns The SSO login URL for Centrix Positive Pay.
     * @throws Error if the response does not contain a valid SSO URL.
     */
    public async getCentrixSsoUrl(): Promise<string> {
        const response = await this.arpClient.arpGetCentrixSsoLogin();
        const ssoLoginUrl = response.data?.ssoLoginUrl;

        if (!ssoLoginUrl) {
            throw new Error(
                'We were unable to complete your request at this time. Please contact your financial institution for additional information.'
            );
        }

        return this.validateSsoUrl(ssoLoginUrl);
    }

    private validateSsoUrl(url: string): string {
        try {
            const parsed = new URL(url);
            if (parsed.protocol !== 'https:') {
                throw new Error('Invalid Centrix SSO URL protocol');
            }
            return url;
        } catch {
            throw new Error(
                'We were unable to complete your request at this time. Please contact your financial institution for additional information.'
            );
        }
    }
}
